import { motion } from "framer-motion";
import { ConsultationBooking } from "@/components/ConsultationBooking";

export const Consultation = () => {
  return (
    <section id="consult" data-testid="consultation-section" className="border-t border-slate-200 bg-[#FFFFFF] py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-2 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#6D28D9]/90">Talk to the desk</p>
          <h2 className="font-display mt-4 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Book a <span className="gold-text">private consultation</span>
          </h2>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-500">
            Get a focused one-on-one with our desk on pricing, availability, transfer mechanics and how a specific unlisted name fits your portfolio. Secure your slot with a booking fee — fully applied to your engagement.
          </p>
          <ul className="mt-8 space-y-3">
            {["Live indicative pricing & lot availability", "Transfer & settlement walkthrough", "Portfolio-fit and risk discussion"].map((t) => (
              <li key={t} className="flex items-start gap-3 text-sm text-slate-700">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 bg-[#6D28D9]" />
                {t}
              </li>
            ))}
          </ul>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <ConsultationBooking />
        </motion.div>
      </div>
    </section>
  );
};
